import React from "react";
import { Control, Controller } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/de";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  defaultValue?: any;
  onChange?: (value: any) => void;
}

const FormDatePicker: React.FC<Props> = (props) => {
  const { control, fieldName, label, required, disabled, onChange } = props;

  const handleOnChange = (value: any) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        required: {
          value: required!,
          message: "Required",
        },
      }}
      render={({
        field: { onChange, value, ...restField },
        fieldState: { error },
      }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
          <DatePicker
            {...restField}
            format="MM.DD.YYYY"
            label={label}
            value={value ? dayjs(value) : null}
            onChange={(value) => {
              let date = dayjs(value)?.toDate();
              onChange(date);
              handleOnChange(date);
            }}
            disabled={disabled}
            slotProps={{
              field: { clearable: true },
              textField: {
                error: !!error,
                helperText: error ? error.message : null,
                fullWidth: true,
                variant: "outlined",
              },
            }}
          />
        </LocalizationProvider>
      )}
    />
  );
};

export default FormDatePicker;
